import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import searchIcon from '../../../assets/icons/search.svg';
import sparklesIcon from '../../../assets/icons/sparkles.svg';
import { Body, Heading2 } from '../../../components/Typography';

export default function TailorSearchButton({ className, onClick }: { className?: string; onClick?: () => void }) {
  const { t } = useTranslation();

  return (
    <button
      id="ostro-tailor-search-button"
      className={twMerge('relative border-b-1 border-dotted border-black block w-full text-left', className)}
      onClick={onClick}
    >
      <img
        className="left-0 top-0 absolute mr-1 mt-2.5 inline"
        src={searchIcon}
        alt="Search Icon"
      />
      <Heading2 className="ml-7 cursor-pointer w-full inline-block placeholder-typography-heading py-2 px-1 bg-transparent outline-none">
        {t('search_placeholder')}
      </Heading2>
      <Body className="absolute top-4 transform -translate-y-1/2 left-[155px] min-w-[120px] inline-block translate-x-[-50%] text-typography-secondary">
        {t('search_ai_powered_caption')}
        <img
          src={sparklesIcon}
          alt="Sparkles"
          className="inline ml-0.5 mb-1"
        />
      </Body>
    </button>
  );
}
